import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import Navbar from "../components/Navbar";
import pricingbg from "../assets/pricing.png";


// Load your Stripe public key
const stripePromise = loadStripe(
  "pk_live_51QCISBFMRr3ALRAlbjdE5UynYZDJjX4ntVQsQrOqitY5EWe6M89uYAyRy3QU0hmXHYS37MnQfOoQkMD6a4rcuS3M006rU67sdX"
);

function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planType, setPlanType] = useState('monthly');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    email: '',
    mobileNumber: '',
    message: '',
    plan:''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handlePlanSelect = async (plan) => {
    try {
      // Fetch the Checkout session from your backend
      if (planType === 'yearly') {
        plan = `${plan}/Year`;
      }

      console.log(`Sending plan to backend: ${plan}`);
      const response = await fetch(
        "https://api-issp7n7t4a-uc.a.run.app/create-checkout-session",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ plan }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to create checkout session.");
      }

      const { url } = await response.json();

      // Redirect to Stripe Checkout
      window.location.href = url;
    } catch (error) {
      console.error("Error redirecting to checkout:", error);
      alert("There was an error. Please try again.");
    }
  };

  const handlePlanChange = (event) => {
    setPlanType(event.target.value);
  };

  const getPrice = (monthlyPrice) => {
    if (planType === 'yearly') {
      return (monthlyPrice * 12 * 0.9).toFixed(2); // 10% discount for yearly plan
    }
    return monthlyPrice.toFixed(2);
  };

  const closeModal = () => {
    setSelectedPlan(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };
  const handleSubmit = async (e) => {

    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://api-issp7n7t4a-uc.a.run.app/api/premimum-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('Thank You! We will get back to you soon');
        handleDialogClose();
      } else {
        alert('Failed to submit the form. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error. Please try again.');
    } finally {
      setIsSubmitting(false); // Reset the "submitting" state after the request completes
    }
  };

  return (
    <div className="bg-white text-black min-h-screen flex flex-col mt-20" style={{
      backgroundImage: `url(${pricingbg})`,
    }}
    >
      <Navbar className="bg-gray-900 text-gray-200 py-4" />

      <div className="flex-1">
        <div className="mx-auto mt-9 max-w-7xl px-6 lg:px-9">
          <div className="mx-auto max-w-2xl sm:text-center">
            <h2 className="text-3xl text-white font-bold tracking-tight sm:text-4xl">
              Streamlined GST Reconciliation with ATO Integration
            </h2>
            <p className="mt-6 text-lg text-white leading-8">
              Choose the plan that fits your business needs and enjoy seamless
              GST reconciliation with automated ATO reporting and Xero
              integration.
            </p>
          </div>
          <div className="mt-6 flex justify-center">
            <label className="mr-4 text-white">
              <input
                type="radio"
                value="monthly"
                checked={planType === 'monthly'}
                onChange={handlePlanChange}
              />
              Monthly
            </label>
            <label className="text-white">
              <input
                type="radio"
                value="yearly"
                checked={planType === 'yearly'}
                onChange={handlePlanChange}
              />
              Yearly (10% discount)
            </label>
          </div>
          <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12 pb-12">
            {/* Basic Plan */}
            <div className="bg-black text-white bg-opacity-90 rounded-3xl p-6">
              <h3 className="text-2xl font-bold">Basic Plan</h3>
              <p className="mt-6 text-base leading-7">
                Ideal for small businesses looking for basic GST reconciliation
                and ATO reporting features. Integrates with MYOB and Xero for a
                streamlined experience.
              </p>
              <div className="mt-4 flex items-center gap-x-4">
                <h4 className="text-sm font-semibold text-indigo-400">
                  Features
                </h4>
                <div className="h-px flex-auto bg-gray-500"></div>
              </div>
              <ul role="list" className="mt-8 text-sm leading-6 space-y-4">
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Basic GST
                  Reporting [BAS Summary]
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Integration with
                  ATO and Xero
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Basic ATO and Xero
                  Compliance [ITA Statement, ICA Statement and Reason for variance]
                </li>
              </ul>
              <div className="mt-20 text-center">
                <p className="text-lg font-semibold"> ${getPrice(29)} {planType === 'monthly' ? '/ month' : '/ year'}</p>
                <button
                  className="mt-4 bg-indigo-800 text-white py-2 px-4 rounded"
                  onClick={() => handlePlanSelect("Basic Plan")}
                >
                  Select Plan
                </button>
              </div>
            </div>

            {/* Standard Plan */}
            <div className="bg-black text-white bg-opacity-90 rounded-3xl p-4">
              <h3 className="text-2xl font-bold">Standard Plan</h3>
              <p className="mt-6 text-base leading-7">
                Perfect for growing businesses needing advanced GST
                reconciliation and enhanced ATO compliance with additional
                automation features.
              </p>
              <div className="mt-12 flex items-center gap-x-4">
                <h4 className="text-sm font-semibold text-indigo-400">
                  Features
                </h4>
                <div className="h-px flex-auto bg-gray-500"></div>
              </div>
              <ul role="list" className="mt-6 text-sm leading-6 space-y-4">
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Advanced GST
                  Reporting [BAS Summary, ICA Statement, ITA Statement, Reason for variance, Payroll Summary]
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Enhanced
                  Reporting [Activity Statements, GST Reconciliation Report, Aged Payable Summary, Aged Receivable Summary]
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Priority Email
                  Support
                </li>
              </ul>
              <div className="mt-10 text-center">
                <p className="text-lg font-semibold"> ${getPrice(49)} {planType === 'monthly' ? '/ month' : '/ year'}</p>
                <button
                  className="mt-4 bg-indigo-800 text-white py-2 px-4 rounded"
                  onClick={() => handlePlanSelect("Standard Plan")}
                >
                  Select Plan
                </button>
              </div>
            </div>

            {/* Premium Plan */}
            <div className="bg-black text-white bg-opacity-90 rounded-3xl p-4">
              <div className="flex items-center gap-x-2">
                <h3 className="text-2xl font-bold">Premium Plan</h3>
                <span className="text-xls text-indigo-400 font-semibold">(Recommended)</span>
              </div>
              <p className="mt-6 text-base leading-7">
                Comprehensive plan for large enterprises requiring advanced
                features, including full automation and custom integration
                solutions for ATO and Xero.
              </p>
              <div className="mt-12 flex items-center gap-x-4">
                <h4 className="text-sm font-semibold text-indigo-400">
                  Features
                </h4>
                <div className="h-px flex-auto bg-gray-500"></div>
              </div>
              <ul role="list" className="mt-6 text-sm leading-6 space-y-4">
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Advanced GST Reporting
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Valid for up to 4 users
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span>  Premium Support
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Custom Integration Solutions
                </li>
                <li className="flex gap-x-3">
                  <span className="text-indigo-400">✔️</span> Comprehensive ATO Compliance
                </li>
              </ul>
              <div className="mt-14 text-center">
                <p className="text-lg font-semibold"> ${getPrice(89)} {planType === 'monthly' ? '/ month' : '/ year'}</p>
                <button
                  className="mt-4 bg-indigo-800 text-white py-2 px-4 rounded"
                  onClick={handleDialogOpen}
                >
                  Contact Us
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
      {isDialogOpen && (
  <div className="fixed mt-20 inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
    <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
      <h2 className="text-2xl font-semibold mb-4 text-center text-blue-600">Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="block text-gray-700 text-sm font-medium">Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleInputChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 text-sm font-medium">Organization Name</label>
          <input
            type="text"
            placeholder="Enter your Organization name"
            name="companyName"
            value={formData.companyName}
            onChange={handleInputChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 text-sm font-medium">Organization Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your Organization mail Id"
            value={formData.email}
            onChange={handleInputChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 text-sm font-medium">Mobile Number</label>
          <input
            type="text"
            placeholder="Enter your mobile number"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleInputChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 text-sm font-medium">Choose Plan</label>
          <select
            name="plan"
            value={formData.plan}
            onChange={handleInputChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Plan</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 text-sm font-medium">Message</label>
          <textarea
            name="message"
            placeholder="Tell us about your Company"
            value={formData.message}
            onChange={handleInputChange}
            required
            rows="2"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
</div>


              {/* <div className="mb-4">
                <label className="block text-gray-700">Email ID 1</label>
                <input
                  type="email"
                  name="email1"
                  value={formData.email1}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Email ID 2</label>
                <input
                  type="email"
                  name="email2"
                  value={formData.email2}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border rounded"
                />
                 </div>
              <div className="mb-4">
                <label className="block text-gray-700">Email ID 3</label>
                <input
                  type="email"
                  name="email3"
                  value={formData.email3}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Email ID 4</label>
                <input
                  type="email"
                  name="email4"
                  value={formData.email4}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border rounded"
                />
              </div> */}
              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-gray-500 text-white py-2 px-4 rounded mr-2"
                  onClick={handleDialogClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`bg-blue-500 text-white py-2 px-4 rounded ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Payment Modal */}
      {selectedPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-8 rounded-lg max-w-md w-full">
            <h2 className="text-2xl font-bold mb-4">
              Subscribe to {selectedPlan}
            </h2>
            <button
              className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Pricing;
